export const integrations = {
	integrations: "Integraciones",
	integrationsDescription:
		"Accede a datos de operación vía API de Zig: tienda, ventas, fiscales, bonos, recargas y más.",
	createDrawer: {
		addPlaces: "Vincular places",
		addPlacesDescription: "Selecciona los places que deseas vincular a este token.",
		selectPlaces: "Selecciona los places",
		selectAll: "Seleccionar todos",
		generateTokenMessage:
			"Este token será generado y vinculado a todos los places seleccionados ({{count}}). Podrá ser usado para autenticar integraciones con la API Zig solo en estos places. ¿Deseas continuar?",
		generateTokenMessageAllPlaces:
			"Este token será generado y vinculado a todos los places seleccionados (atuais y futuros). Podrá ser usado para autenticar integraciones con la API Zig solo en estos places. ¿Deseas continuar?",
		generateTokenConfirm: "Generar token y vincular a los places",
		cancelTokenMessage:
			"Al cancelar, el token no será creado y la selección de los places será descartada. ¿Deseas continuar de todas formas?",
		cancelToken: "Cancelar token",
		linkToAllPlaces: "Vincular a todos los places",
		allPlacesPlaceholder: "Todos los places seleccionados (atuais y futuros)",
	},
	token: "Token",
	createToken: "Generar Token",
	techDocumentation: "Documentación técnica",
	searchPlaceholder: "Buscar por place ID",
	noContentTitle: "Aún no hay nada por aquí",
	noContentDescription:
		"Genera un token para integrar sistemas externos con la API Zig. Cópialo y úsalo en la autenticación.",
	noDataTitle: "No encontramos lo que buscas",
	noDataDescription: "El place no fue encontrado.",
	generatedBy: "Generado por | ",
	generatedByDate: " el ",
	generatedByTime: " a las ",
	viewLinkedPlaces: "Ver places vinculados",
	linkedPlaces: "Places vinculados",
	copyToken: "Copiar token",
	copyTokenButtonSuccess: "Copiado",
	copyTokenTooltip: "Copiar token completo para autenticación vía API",
	copyTokenSuccess: "El código del token fue copiado al portapapeles",
	deleteToken: "Eliminar token",
	deleteTokenConfirm: "Eliminar token",
	deleteTokenConfirmMessage:
		"Al eliminar este token, podrías afectar integraciones en curso de todos los places vinculados a él. ¿Deseas continuar de todas formas?",
	successCreateToken: "Token creado exitosamente",
	successDeleteToken: "Token eliminado exitosamente",
	alertTitle:
		"El token otorga acceso total a la API de Zig. Úsalo solo en integraciones seguras.",
	alertDescription: "Una vez creado, permanecerá activo hasta ser eliminado.",
	tokenListTitle: "API Token",
	orgInfo: "Red | ",
	allPlacesToken: "Todos los places",
};
